(ns frontend.view.modals.hidden-emails.events
  "Re-frame events for hidden emails modal"
  (:require
   [frontend.actions.account :as account-actions]
   [frontend.logging :as logging]
   [frontend.state.current-session :as session]
   [re-frame.core :as rf]))

(def ^:private root-path [::state])

(rf/reg-sub
 ::unhiding?
 (fn [db]
   (get-in db (conj root-path :unhiding?) false)))

(rf/reg-event-fx
 ::unhide-email
 (fn [{db :db} [_ {:keys [email close-modal!]}]]
   {:db (assoc-in db (conj root-path :unhiding?) true)
    ::unhide-email-fx {:email email :close-modal! close-modal!}}))

(rf/reg-fx
 ::unhide-email-fx
 (fn [{:keys [email close-modal!]}]
   (let [current-prefs (:account/preferences @session/account)
         current-hidden (set (get current-prefs :outlook-addin-hidden-emails #{}))
         updated-hidden (disj current-hidden email)]
     (account-actions/*->update-preferences
      {:account/preference {:outlook-addin-hidden-emails updated-hidden}}
      (fn [_] (rf/dispatch [::on-email-unhidden close-modal!]))
      (fn [err] (rf/dispatch [::on-unhide-error err]))))))

(rf/reg-fx
 ::close-modal
 (fn [close-modal!]
   (when (fn? close-modal!)
     (close-modal!))))

(rf/reg-event-fx
 ::on-email-unhidden
 (fn [{db :db} [_ close-modal!]]
   (cond-> {:db (assoc-in db (conj root-path :unhiding?) false)}
     (fn? close-modal!) (assoc ::close-modal close-modal!))))

(rf/reg-event-fx
 ::on-unhide-error
 (fn [{db :db} [_ err]]
   (logging/error "Failed to unhide email" err)
   {:db (assoc-in db (conj root-path :unhiding?) false)}))
